import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { GlobalService } from 'app/shared/global.service';

@Injectable({
  providedIn: 'root'
})
export class PaymentGatewayService {

  constructor(private http: HttpClient, public router: Router, private globals: GlobalService) { }

  // Getting Payment Gateway Details by ClientID and LocationID
  GetPaymentGatewayDetails(ClientID, LocationID, PaymentGateway) {
    const customHeaders = this.globals.GetCustomHeadersForGet();
    return this.http.get<any>(environment.apiUrl + 'paymentgateway/GetPaymentGatewayDetails?ClientID=' + ClientID
      + '&LocationID=' + LocationID + '&PaymentGateway=' + PaymentGateway, { headers: new HttpHeaders(customHeaders) })
      .pipe(
        catchError((error: any) => {
          throw error;
        }));
  }


  // getting razorpay refresh token
  GetRazorpayRefreshToken(Application_ClientID, Application_ClientSecret, Refresh_Token, PaymentGatewayTypeID, ClientID, LocationID) {
    const customHeaders = this.globals.GetCustomHeadersForPost();
    return this.http.post<any>(environment.apiUrl + 'paymentgateway/GetRazorpayRefreshToken?Application_ClientID=' + Application_ClientID +
      '&Application_ClientSecret=' + Application_ClientSecret + '&Refresh_Token=' + Refresh_Token +
      '&PaymentGatewayTypeID=' + PaymentGatewayTypeID + '&ClientID=' + ClientID + '&LocationID=' + LocationID, { headers: new HttpHeaders(customHeaders) })
      .pipe(map(data => data),
        catchError((error: any) => {
          throw error;
        }));
  }


  createOrder(amount: number, key, secret, Access_Token) {
    // Define headers
    const headers = this.globals.GetCustomHeadersForPost();

    // Request body
    const body = {
      Amount: amount, // Amount in INR
      Currency: 'INR',
      Receipt: 'order_rcpt_123',
      Notes: 'Hospital bill payment',
      PaymentGateway_key: key,
      PaymentGateway_secret: secret,
      Access_Token: Access_Token
    };

    // Make POST request with headers
    return this.http.post(environment.apiUrl + 'paymentgateway/CreateOrder', body, { headers });
  }

  CreateOrderWithKeySecret(itemToEditRazorpayBookingAndYoga) {
    // Define headers
    //amount: number, key, secret, Access_Token, SelectedOnlinePatientRegistrationID, PatientID, MinBedCount, BookingID, SelectedClassID, selectedAliesName,
    //AdmissionDuration, ExpectedArival, CheckinDate, advanceReceiptBook, CarryforwardBookingID, CarryForwardAmount
    const headers = this.globals.GetCustomHeadersForPost();

    // Request body
    const body = itemToEditRazorpayBookingAndYoga;
    // {
    //   Amount: amount, // Amount in INR
    //   Currency: 'INR',
    //   Receipt: 'order_rcpt_123',
    //   Notes: 'Hospital bill payment',
    //   PaymentGateway_key: key,
    //   PaymentGateway_secret: secret,
    //   Access_Token: Access_Token,
    //   OnlinePatientRegistrationID: SelectedOnlinePatientRegistrationID,
    //   PatientID: PatientID
    // };

    // Make POST request with headers
    return this.http.post(environment.apiUrl + 'paymentgateway/CreateOrderWithKeySecret', body, { headers });
  }

  GetPaymentGatewayAuthorize(ClientID, LocationID, PaymentGatewayTypeID, Code, State, client_id, client_secret) {
    // Define headers
    const headers = this.globals.GetCustomHeadersForPost();

    // Request body
    const body = {
      Amount: 0, // Amount in INR
      Currency: 'INR',
      Receipt: 'order_rcpt_123',
      Notes: 'Hospital bill payment',
      authorizationCode: Code,
      authorizationState: State,
      Application_ClientID: client_id,
      Application_ClientSecret: client_secret,
      ClientID: ClientID,
      LocationID: LocationID,
      PaymentGatewayTypeID: PaymentGatewayTypeID,
    };

    // Make POST request with headers
    return this.http.post(environment.apiUrl + 'paymentgateway/GetPaymentGatewayAuthorize', body, { headers });
  }

  // Razorpay Verify Payment Signature
  VerifyPaymentSignature(PaymentVerificationRequest) {
    const customHeaders = this.globals.GetCustomHeadersForPost();
    return this.http.post<any>(environment.apiUrl + 'paymentgateway/VerifyPaymentSignature', PaymentVerificationRequest, { headers: new HttpHeaders(customHeaders) })
      .pipe(map(data => data),
        catchError((error: any) => {
          throw error;
        }));
  }

  //Getting Payment Details by razorpay paymentid and clientsecret
  GetPaymentAndOrderDetails(PaymentID, OrderID, ClientID, ClientSecret) {
    const customHeaders = this.globals.GetCustomHeadersForGet();
    return this.http.get<any>(environment.apiUrl + 'paymentgateway/GetPaymentAndOrderDetails?PaymentID=' + PaymentID +
      '&OrderID=' + OrderID + '&ClientID=' + ClientID + '&ClientSecret=' + ClientSecret, { headers: new HttpHeaders(customHeaders) })
      .pipe(map(data => data),
        catchError((error: any) => {
          throw error;
        }));
  }
}
